import React, { useEffect } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { fetchClusterList } from '@/slices/resourceSlice';
import Panel from '@/components/Panel';
import Right from './Right';
import Left from './Left';

function WebSSH({ fetchClusterList }) {
  useEffect(() => {
    fetchClusterList();
  }, [fetchClusterList]);

  return (
    <Root className='narrow-scrollbar'>
      <Left />
      <Right />
    </Root>
  );
}

export default connect(null, {
  fetchClusterList,
})(WebSSH);

const Root = styled(Panel)`
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  .shadow-card-body {
    display: flex;
    padding: 0;
    flex: 1;
  }
`;
